import SecureStorage from "@gcloud-npm/utils.secure.local-storage";
import { findOutEnvByEnvName } from "@gcloud-npm/utils.enums.environment";
import getCookie from "@gcloud-npm/utils.common.get-cookie";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda"
import logOutApi from "@gcloud-npm/adabyron.abs-layer.logout";
import deleteCookie from "@gcloud-npm/utils.common.delete-cookie";

const COOKIE_LOGOUT_REDIRECT = "seth-logout-redirect"
const COOKIE_PERSO = '@sc';
const COOKIE_PERSO_FINAL = 'sc';
const DEBUG = localStorage.getItem('AUTH_DEBUG');

const debugLog = (sms) => {
  if(DEBUG){
    console.log(sms)
  }
}

const secureStorage = new SecureStorage();



async function main() {
  const sonda = new FrontSonda({
    kind: "FATAL",
    processName: 'auth/logout/main', 
    filePath: 'index.js', 
    projectId: 'logout'
  })



  try {   
    deleteCookie(COOKIE_PERSO_FINAL, '/', '.movistar.es');
  } catch(error){
    console.log(error)
    sonda.errorMessage({error});
  }
  
  try {   
    deleteCookie(COOKIE_PERSO, '/', '.movistar.es');
  } catch(error){
    console.log(error)
    sonda.errorMessage({error});
  }

  try {
    const environment = findOutEnvByEnvName(process.env.NEXT_PUBLIC_ENV_NAME);
    const context = { environment }
    await logOutApi({ context, build: false })
  } catch(error) {
    sonda.errorMessage({error});
  }
  let redirectUrl = "https://www.movistar.es/" 
  try {
    const redirectUrlCookieValue = getCookie(COOKIE_LOGOUT_REDIRECT);
    if(redirectUrlCookieValue){
      redirectUrl= redirectUrlCookieValue
    } 
    secureStorage.removeItem('ts')
    deleteCookie(COOKIE_LOGOUT_REDIRECT, '/', '.movistar.es');
  } catch(e){
    sonda.errorMessage({error});
  }


  window.location.href = redirectUrl;

}

main();
